import { render, staticRenderFns } from "./StyleListAddNew.vue?vue&type=template&id=471cb27d&"
import script from "./StyleListAddNew.vue?vue&type=script&lang=js&"
export * from "./StyleListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StyleListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports